export default "__VITE_ASSET__Bs1mjj7a__"